import moment from 'moment'

export const checkLockerYearDateValidation = (formFieldValue) => {
  let validations = []

  if (formFieldValue?.year_open_date && formFieldValue?.from_date) {
    if (!moment(formFieldValue.year_open_date).isBefore(moment(formFieldValue.from_date))) {
      validations.push({
        field: 'year_open_date',
        message: 'Year open date should be before from Rental starts on date',
      })
    }
  }
  if (formFieldValue?.year_open_date && formFieldValue?.year_close_date) {
    if (!moment(formFieldValue.year_open_date).isBefore(moment(formFieldValue.from_date))) {
      validations.push({
        field: 'year_open_date',
        message: 'Year open date should be before from Year close date',
      })
    }
  }
  if (formFieldValue?.from_date && formFieldValue?.to_date) {
    if (!moment(formFieldValue.from_date).isBefore(moment(formFieldValue.to_date))) {
      validations.push({
        field: 'year_open_date',
        message: 'Rental start date should be before from Rental End Date',
      })
    }
  }
  if (formFieldValue?.send_renewal_email_after && formFieldValue?.renewal_email_close_date) {
    if (!moment(formFieldValue.send_renewal_email_after).isBefore(moment(formFieldValue.renewal_email_close_date))) {
      validations.push({
        field: 'send_renewal_email_after',
        message: 'Send renewal email after date should be before from Renewal email close date',
      })
    }
  }
  if (formFieldValue?.send_renewal_email_after && formFieldValue?.to_date) {
    if (!moment(formFieldValue.send_renewal_email_after).isBefore(moment(formFieldValue.to_date))) {
      validations.push({
        field: 'send_renewal_email_after',
        message: 'Send renewal email after date should be before from Rental End date',
      })
    }
  }
  if (formFieldValue?.year_close_date && formFieldValue?.from_date && formFieldValue?.to_date) {
    if (!moment(formFieldValue.year_close_date).isBefore(moment(formFieldValue.to_date))) {
      validations.push({
        field: 'year_close_date',
        message: 'Year End date should be before from Rental End Date',
      })
    }
    if (!moment(formFieldValue.year_close_date).isAfter(moment(formFieldValue.from_date))) {
      validations.push({
        field: 'year_close_date',
        message: 'Year End date should be After from Rental start Date',
      })
    }
  }
  if (formFieldValue?.code_issued_after && formFieldValue?.year_open_date && formFieldValue?.year_close_date) {
    if (!moment(formFieldValue.code_issued_after).isAfter(moment(formFieldValue.year_open_date))) {
      validations.push({
        field: 'year_close_date',
        message: 'Code issue after date should be After from Year open date',
      })
    }
    if (!moment(formFieldValue.code_issued_after).isBefore(moment(formFieldValue.year_close_date))) {
      validations.push({
        field: 'year_close_date',
        message: 'Code issue after date should be before from Year close date',
      })
    }
  }

  let isAllFieldAdded = true
  const fields = [
    'from_date',
    // 'send_renewal_email_after',
    'year_open_date',
    // 'renewal_email_close_date',
    'code_issued_after',
    'to_date',
    'year_close_date',
  ].map((item) => {
    if (!formFieldValue[item]) {
    
      isAllFieldAdded = false
    }
  })
  if (!isAllFieldAdded) {
    validations.push({
      field: 'year_close_date',
      message: 'All dates are required',
    })
  }


  return validations
}

export function getAcademicYearDates() {
  const today = new Date()
  const currentYear = today.getFullYear()
  const sepFirst = new Date(currentYear, 8, 1)
  const yearOffset = today > sepFirst ? 1 : 0

  const from_date = new Date(currentYear + yearOffset, 8, 1).setHours(0, 0, 0, 0)
  const to_date = new Date(currentYear + yearOffset + 1, 7, 31).setHours(0, 0, 0, 0)
  const year_open_date = new Date(currentYear + yearOffset, 4, 1)
  const year_close_date = new Date(currentYear + yearOffset + 1, 6, 1)
  const code_issued_after = new Date(currentYear + yearOffset, 7, 24)
  const send_renewal_email_after = new Date(currentYear + yearOffset, 3, 1)
  const renewal_email_close_date = new Date(currentYear + yearOffset, 4, 1)

  return { from_date, to_date, year_close_date, year_open_date, code_issued_after, send_renewal_email_after, renewal_email_close_date }
}

export function getSelectedRateType(gridRelatedData) {
  if (gridRelatedData?.savedFilters?.[gridRelatedData?.tableGrid?.name]?.['rate_type_id']) {
    return gridRelatedData?.savedFilters?.[gridRelatedData?.tableGrid?.name]?.['rate_type_id']
  }
  return
}
